export const ASSIGNMENT_TRIAL_ACCESS_TYPES = {
    NONE: {
        value: 0,
        label: 'None',
    },
    SUBMISSIONS: {
        value: 1,
        label: 'Submissions',
    },
    DATE: {
        value: 2,
        label: 'Date',
    },
}
